import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { Link } from "@swo/shared";
import { css } from "@emotion/react";
import { CSS_SPACER_SIZES } from "../../../styles/styles-css-variables";
import { SwarovskiButton } from "../../../components/_shared-components/ui-elements/SwarovskiButton";
import React from "react";

export const IconsAndTextComponentBottomRow: ReactTFC<{ bottomText: string; callToAction: Link }> = props => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: ${CSS_SPACER_SIZES.md} auto ${CSS_SPACER_SIZES.sm} auto;
        max-width: var(--max-content-width-new);
      `}
    >
      <span
        css={css`
          text-align: center;
        `}
      >
        {props.bottomText}
      </span>

      <SwarovskiButton
        as={"a"}
        isInternal={props.callToAction.type === "Internal Link"}
        link={props.callToAction.data}
        variant={"ghost-underline"}
        target={!!props.callToAction.openInNewTab ? "_blank" : undefined}
        rel={!!props.callToAction.openInNewTab ? "noopener noreferrer" : undefined}
      >
        {props.callToAction.label}
      </SwarovskiButton>
    </div>
  );
};
